<script lang="ts">
import { classname } from '@/js/utils.js';

const classOrderDetails = classname('order-details');
export default {
  name: 'AppOrderDetails',
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: null,
    },
    isHeading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    classOrderDetails,
  },
};
</script>

<template>
  <div :class="classOrderDetails({ no_heading: !isHeading, size })">
    <div :class="classOrderDetails('title-wrapper')">
      <div :class="classOrderDetails('title')">
        <slot name="title" />
      </div>
      <div :class="classOrderDetails('additional')">
        <slot name="additional" />
      </div>
    </div>
    <slot name="map" />
    <div :class="classOrderDetails('inner')">
      <slot name="content" />
    </div>
  </div>
</template>

<style lang="scss">
.order-details {
  display: grid;
  grid-gap: 26px;
  padding-inline: 36px;
  background-color: #fff;

  &__title-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-size: 24px;
  }

  &__additional {
    font-size: 18px;
  }

  &__inner {
    display: grid;
    grid-gap: 26px;
  }

  &_no {
    &_heading {
      .order-details__title-wrapper {
        display: none;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    padding-inline: 20px;
  }

  @media screen and (max-width: 991px) {
    padding: 0;
    gap: 24px;

    &__title {
      font-weight: 500;
      font-size: 16px;
    }
    &__inner {
      grid-gap: 16px;
    }
  }

  @media screen and (max-width: 500px) {
    &_size {
      &_large {
        .order-details__inner {
          grid-gap: 26px;
        }
      }
    }
  }
}
</style>
